import {MeinText} from '@components/@typography/MeinText';
import {BusEventEnum, EventBus} from '@core/eventBus';
import {useClickAway} from '@hooks/useClickAway';
import {Popper} from '@mui/material';
import classNames from 'classnames';
import {MouseEventHandler, useEffect, useState} from 'react';
import {useVideoPlayer, useVideoPlayerState} from '../../useVideoPlayer';
import {VideoControlsItem} from '../Item/VideoControlsItem';
import styles from './VideoPlaybackRateButton.module.css';

import {Icon} from '@components/@icons';
const playbackRates = [0.5, 0.75, 1, 1.25, 1.5, 2];

export const VideoPlaybackRateButton = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const handleClick: MouseEventHandler<HTMLDivElement> = e => {
        setAnchorEl(e.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        const sub = EventBus.on(
            BusEventEnum.VIDEO_PLAYER_CLOSE_MENU,
            handleCloseMenu,
        );
        return () => {
            sub.unsubscribe();
        };
    }, []);

    const {changePlaybackRate} = useVideoPlayer();
    const currentPlaybackRate = useVideoPlayerState(s => s.playbackRate);

    const handleChangePlaybackRate = (rate: number) => {
        changePlaybackRate(rate);
        setAnchorEl(null);
    };

    const ref = useClickAway(handleCloseMenu);

    const isOpen = Boolean(anchorEl);
    const id = isOpen ? 'playback-rate-popper' : undefined;

    return (
        <>
            <VideoControlsItem onClick={handleClick} aria-describedby={id}>
                <Icon name="gauge-speedometer" className={styles.icon} />
            </VideoControlsItem>
            <Popper
                id={id}
                open={isOpen}
                anchorEl={anchorEl}
                placement="top"
                className={styles.popper}
                ref={ref}
            >
                <div
                    className={styles.playbackRatePopper}
                    onMouseLeave={handleCloseMenu}
                >
                    {playbackRates.map(rate => (
                        <button
                            key={rate}
                            onClick={e => {
                                e.stopPropagation();
                                handleChangePlaybackRate(rate);
                            }}
                            className={classNames(styles.playbackRateItem, {
                                [styles.active]: currentPlaybackRate === rate,
                            })}
                        >
                            <MeinText className={styles.playbackRateItemText}>
                                {rate}
                            </MeinText>
                        </button>
                    ))}
                </div>
            </Popper>
        </>
    );
};
